export var SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export var SEARCH_FAILED = 'SEARCH_FAILED';
export var SEARCH_INITIATED = 'SEARCH_INITIATED';
export var UPDATE_CURRENT_PAGE = 'UPDATE_CURRENT_PAGE';
export var UPDATE_SORT_ORDER = 'UPDATE_SORT_ORDER';
export var SET_NEARBY_AGENTS = 'SET_NEIGHBOUR_AGENTS';